import React from 'react';
import PropTypes from 'prop-types';
import { ArrowRight } from 'lucide-react';
import { Button } from '../../../../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../../../components/ui/dialog';
import { cn } from '../../../../../lib/utils';

function ConfirmChangesDialog({ isOpen, changes, onConfirm, onCancel, isLoading }) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Confirm Changes</DialogTitle>
          <DialogDescription>
            Are you sure you want to apply the following changes?
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 py-4">
          {changes.map((change) => (
            <div key={change.field} className="flex items-center gap-3 p-3 rounded-lg bg-muted/50">
              <span className="text-sm font-medium w-24 shrink-0">{change.field}:</span>
              <div className="flex items-center gap-2 flex-1 min-w-0">
                <span
                  className={cn(
                    'px-2 py-1 rounded text-xs font-medium truncate',
                    'bg-red-500/10 text-red-600',
                  )}
                >
                  {change.from || '-'}
                </span>
                <ArrowRight className="h-4 w-4 text-muted-foreground shrink-0" />
                <span
                  className={cn(
                    'px-2 py-1 rounded text-xs font-medium truncate',
                    'bg-green-500/10 text-green-600',
                  )}
                >
                  {change.to || '-'}
                </span>
              </div>
            </div>
          ))}
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onCancel} disabled={isLoading}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={isLoading}>
            {isLoading ? 'Saving...' : 'Confirm'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

ConfirmChangesDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  changes: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string.isRequired,
      from: PropTypes.string,
      to: PropTypes.string,
    }),
  ).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

ConfirmChangesDialog.defaultProps = {
  isLoading: false,
};

export default ConfirmChangesDialog;
